<template>
  <DataListStateful
    title="Типы подвижного состава"
    resource="rolling-stock-types"
    store="rollingStockTypes"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        {
          title: "Тип транспорта",
          name: "type",
          dataPath: "Type.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        transportTypes: {
          title: "Тип транспорта",
          type: "enum",
          resource: "transport-types",
        },
      },
    };
  },
};
</script>
